// docs: https://github.com/altostra/type-validations#readme
import { objectOf /*, maybe */ } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

export const isDeliverabilityPostmasterAppGroupIdDomainReputationResult = objectOf({
  date: string,
  domain: string,
  reputation: string,
  user_reported_spam_ratio: number,
});
